import React from 'react';
import type { InstructionsInfoTab, InstructionsInfoTabKey } from '@app-types/instructions';
import './InstructionsInfoTabs.less';

export interface InstructionsInfoTabsProps {
  tabs: InstructionsInfoTab[];
  /** Selected tab key. Falls back to each tab's own `active` flag when omitted. */
  activeTabKey?: InstructionsInfoTabKey;
  onTabClick?: (tabKey: InstructionsInfoTabKey) => void;
  nodeId?: string;
}

/**
 * Interactive tab row for the Instructions information list.
 * Container has a 2px red bottom border. Active tab has red background,
 * white bold text; inactive tabs have grey background, black medium text.
 * Figma: desktop 3177:10544, mobile 3365:21437.
 */
const InstructionsInfoTabs: React.FC<InstructionsInfoTabsProps> = ({
  tabs,
  activeTabKey,
  onTabClick,
  nodeId,
}) => (
  <div className="instructions-info-tabs" data-node-id={nodeId}>
    <ul className="instructions-info-tabs__list">
      {tabs.map((tab) => {
        const isActive =
          activeTabKey !== undefined ? tab.key === activeTabKey : Boolean(tab.active);

        return (
          <li key={tab.key}>
            <button
              type="button"
              className={`instructions-info-tabs__tab${isActive ? ' is-active' : ''}`}
              aria-pressed={isActive}
              onClick={onTabClick ? () => onTabClick(tab.key) : undefined}
            >
              {tab.label}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);

export default InstructionsInfoTabs;
